import React from 'react';

import Tooltip from '../../shared/Tooltip';
import { AddressDetails } from './Applications';
import { fromISO } from '../../../lib/utils/datetime_formatters';

export default function OwnerInfo({ props }) {
  const { entity, type, ownerAddress, applications } = props;
  const application = applications && applications[0]?.attributes;

  const Birthdate = () => {
    if (type === 'account') return;

    if (entity?.borrower.birthdate) {
      return <p>DOB: {fromISO(entity?.borrower.birthdate).toLocaleString()}</p>;
    } else {
      return (
        <div>
          DOB:
          <Tooltip
            tooltip_text="NetX owners do not provide date of birth during application flow"
            trigger_class="cursor-pointer ml-1.5 font-avenir-book"
            container_class="z-50 text-center p-4 px-6 text-sm text-navy-blue bg-light-blue max-w-xs font-avenir-book"
          >
            N/A - NetX Applicant
          </Tooltip>
        </div>
      );
    }
  };

  return (
    <div className="font-avenir-book capitalize">
      <p className="font-avenir-black tracking-wide text-navy-blue text-lg">
        Owner Info
      </p>
      <div>
        {type === 'company' ? (
          <div className="ph-no-capture">
            <p>First Name: {entity?.borrower.first_name}</p>
            <p>Last Name: {entity?.borrower.last_name}</p>
          </div>
        ) : (
          <p className="ph-no-capture">First Name: {entity?.name}</p>
        )}
        <div className="ph-no-capture">
          <Birthdate />
        </div>
        <p>Owner OFAC Status: {application?.ofac_status}</p>
        <p className="ph-no-capture">FICO: {entity?.applicant_fico_score}</p>
        <p className="ph-no-capture">
          FICO Score Date:{' '}
          {entity?.fico_score_date
            ? fromISO(entity?.fico_score_date).toLocaleString()
            : null}
        </p>
        <div className="ph-no-capture">
          <AddressDetails
            type="owner"
            tooltip={application?.tier === 'Z'}
            tooltip_text={
              application?.tier === 'Z'
                ? 'NetX Applicants do not provide personal address during application flow'
                : ''
            }
            appAddress={ownerAddress}
          />
        </div>
      </div>
    </div>
  );
}
